import {AxiosError} from 'axios';
import {TaskDetailsResponse} from 'web-library/models/Request';
import {GET_DATA_ARCHIVAL_DETAIL_URL} from '../../constants/apiUrls';
import {GET_DATA_ARCHIVAL_DETAIL} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {DataArchivalTemplate} from './useGetDataArchivalTemplate';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================

export type CompleteDataArchivalContent = DataArchivalTemplate & {
  selectedDataLevel?: string[];
  selected?: boolean;
};

export interface DataArchivalDetail extends TaskDetailsResponse {
  content: {
    content: CompleteDataArchivalContent[];
    examYear: string;
  };
}

interface Input {
  uuid: string;
  onSuccess?: (res: DataArchivalDetail) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

// =============================================================================
// Query
// =============================================================================

export const useGetDataArchivalDetail = ({uuid, onError, onSuccess}: Input) => {
  const getDataArchivalDetail = async () => {
    const res = await axiosClient.get<DataArchivalDetail>(GET_DATA_ARCHIVAL_DETAIL_URL(uuid));

    return res.data;
  };

  return useCustomQuery([GET_DATA_ARCHIVAL_DETAIL, uuid], getDataArchivalDetail, {
    onSuccess,
    onError,
  });
};
